import React, { useContext } from 'react';
import { observer } from 'mobx-react';
import { Navigate } from 'react-router-dom';
import { rootContext } from 'stores';
import { Layout } from 'antd';
import Sider from 'components/Sider/Sider';
import { IUser } from 'types';
import { RouteConfigs, RouteConfig } from 'config/routes';

interface ContainerProps extends RouteConfig {
  component: React.ComponentType<any>;
}

export const PrivateContainer: React.FC<ContainerProps> = observer(({ component: Component, ...rest }) => {
  const { AuthStore } = useContext(rootContext);

  const state = AuthStore.state

  if (state?.data?.token && state?.data?.user) {
    if (!IsUserAllowed(rest, state.data.user)) {
      return <Navigate to={RouteConfigs.users.path} />;
    }
    return (
      <>
        <Layout>
          <Sider />
          <Layout.Content className="mainInnerContainer">
            <Component {...rest} />
          </Layout.Content>
        </Layout>
      </>
    );
  }

  return <Navigate to={RouteConfigs.login.path} />;
});

export const IsUserAllowed = (routeData: RouteConfig, user: IUser): boolean => {
  if (!routeData.allowedRoles && !routeData.allowedPermissions) {
    return true;
  } else {
    if (routeData.allowedRoles && routeData.allowedRoles.includes(user?.userType))
      return true;

    if (routeData.allowedPermissions && routeData.allowedPermissions.length) {
      for (let perm of routeData.allowedPermissions) {
        if (user.permissions.includes(perm))
          return true
      }
    }
  }
  return false;
};